import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanDeactivate, Router, RouterStateSnapshot} from '@angular/router';
import {RepositoryService} from 'src/smoothr-web-app-core/services/repository/repository.service';
import {NavigationService} from '../services/navigation.service';

@Injectable()
export class UserIsAnonimusGuard implements CanActivate {
	constructor(
		public repository: RepositoryService,
		private navService: NavigationService
	) {}
	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.repository?.customer?.isAnonymous) {
			this.navService.signUp();
		} else {
			return true;
		}
	}
}
